import React, { useRef, RefObject } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-types-papi';
import EllipsisIcon from '@wix/da-shared-react/pkg/Icons/Ellipsis';
import { actions as modalActions } from '@wix/da-shared-react/pkg/Modals';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { ProfileOwnerGiveState } from '../../../../../../types/profileOwner';
import { getItems } from './utils';

import s from './MoreActionsDropdownMobile.scss';

export interface Props {
  className?: string;
  iconClassName?: string;
  isOwner?: boolean;
  canViewAsVisitor: boolean;
  profileOwnerUser: PapiUser;
  giveState: ProfileOwnerGiveState;
  pushBadgeModal: typeof modalActions.pushBadgeModal;
  pushPointsModal: (username: string, title: string) => void;
  pushBlockModal: (profileOwner: PapiUser) => void;
  showMobileSharePopup: (url: string, title: string) => void;
  onLlamaBadgeSent: () => void;
  onCakeBadgeSent: () => void;
  initGiveState: () => void;
  viewAsVisitor: () => void;
}

export const MoreActionsDropdownMobile: React.FC<Props> = ({
  pushBadgeModal,
  pushPointsModal,
  showMobileSharePopup,
  onLlamaBadgeSent,
  onCakeBadgeSent,
  profileOwnerUser,
  giveState,
  isOwner,
  canViewAsVisitor,
  viewAsVisitor,
  pushBlockModal,
  className,
  initGiveState,
  iconClassName,
}) => {
  const { t } = useTranslation();
  const dropdownRef: RefObject<any> = useRef();
  const logEvent = useBiLogger();

  const handleClick = () => {
    const clickedIndex = dropdownRef.current.value;
    const selectedItem = getItems(t, {
      pushBadgeModal,
      pushPointsModal,
      onLlamaBadgeSent,
      onCakeBadgeSent,
      profileOwnerUser,
      giveState,
      isOwner,
      canViewAsVisitor,
      viewAsVisitor,
      pushBlockModal,
      showMobileSharePopup,
    })[clickedIndex];
    selectedItem.biData && logEvent(selectedItem.biData);
    selectedItem.onClick();
    dropdownRef.current.value = '-1';
  };

  const items = getItems(t, {
    pushBadgeModal,
    pushPointsModal,
    onLlamaBadgeSent,
    onCakeBadgeSent,
    profileOwnerUser,
    giveState,
    isOwner,
    canViewAsVisitor,
    viewAsVisitor,
    pushBlockModal,
    showMobileSharePopup,
  });

  if (items.length === 0) {
    return null;
  }

  return (
    <div className={classnames(s['root'], className)}>
      <div className={s['open-btn']}>
        <EllipsisIcon className={iconClassName} />
      </div>
      <select
        ref={dropdownRef}
        onClick={initGiveState}
        onChange={handleClick}
        defaultValue="-1"
      >
        <option hidden disabled value="-1" />
        {items.map((item, i) => (
          <option key={i} value={i} disabled={item.disabled}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default MoreActionsDropdownMobile;
